module.exports = __webpack_public_path__ + "static/Swisscom_LOGO-3ce919baa73914bde4c6203d367e70db.png";